import { configureStore } from '@reduxjs/toolkit'

import checkoutReducer from '@/features/Checkout/store/checkoutSlice'

export default configureStore({
  reducer: {
    checkout: checkoutReducer
  }
})
